import jQuery from "jquery";

const toggleHeadingRegsiter = () => {
	const el = {
		body: "body.woocommerce-account",
		target: ".heading-register",
		errNotice: ".woocommerce-error",
		expand: "#expandDIv",
	};

	(($) => {
		const init = () => {
			if ($(el.body).length) {
				exec();
			}
		};

		const exec = () => {
			$(el.target).next(".woocommerce-form").hide();
			$(el.target).on("click", function () {
				$(this).toggleClass("expanded");
				$(this).next(".woocommerce-form").css({
					maxHeight: "unset",
				});
				$(this).next(".woocommerce-form").slideToggle();
			});
			if ($(el.errNotice).length && $(el.expand).length) {
				$(el.target).trigger('click');
			}
		};

		init();
	})(jQuery);
};

try {
	toggleHeadingRegsiter();
} catch (error) {
	throw Error(error);
}
